// extracted by mini-css-extract-plugin
export var category = "_lc-9";
export var categoryHeader = "_lc-e";
export var container = "_lc-0";
export var group = "_lc-a";
export var groupItems = "_lc-f";
export var groupSeparator = "_lc-j";
export var loading = "_lc-1";
export var noResults = "_lc-3";
export var placeholder = "_lc-2";
export var resultContent = "_lc-5";
export var resultIcon = "_lc-c";
export var resultItem = "_lc-g";
export var resultMeta = "_lc-8";
export var resultSubtitle = "_lc-7";
export var resultSuffix = "_lc-i";
export var resultTitle = "_lc-6";
export var resultsList = "_lc-4";
export var searchGroup = "_lc-d";
export var selected = "_lc-h";
export var subgroup = "_lc-b";